import { useEffect } from "react";
import { useInput } from "hooks";
import { LabelledInput, LabelledSelect } from "../../../../Fields";

export const IncentiveCreditCard1TextBuilder = ({
  className,
  value = "",
  onChange = () => { },
}) => {
  const type = useInput("No Interest");
  const between = useInput("for");
  const val = useInput(12);
  const time = useInput("months");

  const typeData = [
    { label: "No Interest", value: "No Interest" },
    { label: "No Payments", value: "No Payments" },
    { label: "No Interest or Payments", value: "No Interest or Payments" },
    { label: "0% APR", value: "0% APR" },
  ];
  const typeData2 = [
    { label: "for", value: "for" },
    { label: "until", value: "until" },
  ];
  const timeData = [
    { label: "days", value: "days" },
    { label: "months", value: "months" },
    { label: "years", value: "years" },
  ];

  const handleUpdateValue = (t, b, v, ti) => {
    onChange(`${t} ${b} ${v} ${ti} w/store credit card`);
  };

  useEffect(() => {
    if (value.endsWith("w/store credit card")) {
      let main = value.slice(0, -19).trim();
      const parts = main.split(" ");
      time.setValue(parts[parts.length - 1]);
      val.setValue(parts[parts.length - 2]);
      between.setValue(parts[parts.length - 3]);
      type.setValue(parts.slice(0, -3).join(" "));
    }
    return () => { };
  }, [value]);

  return (
    <>
      <div className="p-2 d-flex justify-content-between align-items-center">
        <LabelledSelect label="Type" style={{ width: '96%' }}
          options={typeData} value={type.value}
          onChange={(e) => {
            type.setValue(e);
            handleUpdateValue(e, between.value, val.value, time.value);
          }} />


        <LabelledSelect label="" className="mt-4" style={{ width: '96%' }}
          options={typeData2} value={between.value}
          onChange={(e) => {
            between.setValue(e);
            handleUpdateValue(type.value, e, val.value, time.value);
          }} />
      </div>
      <div className="p-2 d-flex justify-content-between align-items-center">
        <LabelledInput label="Value" placeholder="Value" style={{ width: '96%' }}
          allowclear="true" value={val.value} inputType="float"
          onChange={(e) => {
            val.setValue(e);
            handleUpdateValue(type.value, between.value, e, time.value);
          }}
        />

        <LabelledSelect label="Time" options={timeData} value={time.value}
          style={{ width: '96%' }}
          onChange={(e) => {
            time.setValue(e);
            handleUpdateValue(type.value, between.value, val.value, e);
          }} />
      </div>
    </>
  );
};